import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { sendHoverSoundCommand, sendTabClickSoundCommand } from 'react-wot-bootstrap'

import {
    FILTERS_ACTIVITY_PLATOON_TITLE,
    FILTERS_ACTIVITY_PLATOON_DESCRIPTION,
    FILTERS_ACTIVITY_STRONGHOLD_TITLE,
    FILTERS_ACTIVITY_STRONGHOLD_DESCRIPTION,
    FILTERS_ACTIVITY_GLOBAL_MAP_TITLE,
    FILTERS_ACTIVITY_GLOBAL_MAP_DESCRIPTION,
    LIST_TYPES,
} from '../../constants.js'

import styles from './Levels.scss'

const LEVELS = [
    {
        listType: LIST_TYPES.CHOICE_1,
        title: FILTERS_ACTIVITY_PLATOON_TITLE,
        description: FILTERS_ACTIVITY_PLATOON_DESCRIPTION,
    },
    {
        listType: LIST_TYPES.CHOICE_2,
        title: FILTERS_ACTIVITY_STRONGHOLD_TITLE,
        description: FILTERS_ACTIVITY_STRONGHOLD_DESCRIPTION,
    },
    {
        listType: LIST_TYPES.CHOICE_3,
        title: FILTERS_ACTIVITY_GLOBAL_MAP_TITLE,
        description: FILTERS_ACTIVITY_GLOBAL_MAP_DESCRIPTION,
    },
]

const Levels = ({ level, onClick }) => {
    const createHandleClick = useCallback((listType) => () => {
        onClick(listType)
        sendTabClickSoundCommand()
    }, [onClick])

    return (
        <div className={styles.base}>
            {LEVELS.map(({ listType, title, description }) => {
                const isSelected = listType === level

                return (
                    <div
                        key={listType}
                        onMouseEnter={isSelected ? undefined : sendHoverSoundCommand}
                        onClick={isSelected ? undefined : createHandleClick(listType)}
                        className={cx(styles.item, isSelected && styles.item__active)}
                    >
                        <div className={styles.title}>{title}</div>
                        <div className={styles.description}>{description}</div>
                    </div>
                )
            })}
        </div>
    )
}

Levels.propTypes = {
    level: PropTypes.string,
    onClick: PropTypes.func.isRequired,
}

export default Levels



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Filters/components/Levels/Levels.jsx